import { connect } from "react-redux";
import get from "lodash/get";
import { getAnaliseSimpleSignals as onGetSimpleSignals } from "../../actions/analiseSignalActions";

const mapStateToProps = (state) => ({
  dataAnalyseDataState: state.dataAnalyse.dataAnalyseDataState,
  deviceId: get(state, ["dataAnalyse", "deviceId"], null),
  headers: get(state, ["dataAnalyse", "headers"], []),
  simpleSignals: get(state, ["dataAnalyse", "simpleSignals"], []),
});

const mapDispatchToProps = { onGetSimpleSignals };

const withDataAnalyse = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withDataAnalyse };
